<template>
  <div id="jobTableSection" class="white">
    <h4>Vacaturekenmerken</h4>
    <b-table-simple small caption-top responsive borderless>
      <b-tbody>
        <b-tr>
          <b-td>Contracttype:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.ContractType)}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Vakgebied:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.Industry)}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Functie:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.JobFunction)}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Opleidingsniveau:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.EducationLevel)}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Regio:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.Region)}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Plaats:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.Place)}}</b-td>
        </b-tr>
        <!-- <b-tr>
          <b-td>Plaatsingsdatum:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.PostingDate)}}</b-td>
        </b-tr>
        <b-tr>
          <b-td>Sluitingsdatum:</b-td>
          <b-td>{{dashIfZeroOrEmpty(job.ClosingDate)}}</b-td>
        </b-tr> -->
        <b-tr>
          <b-td>Uren per week:</b-td>
          <b-td
            v-if="job.MinHours != 0 && job.MaxHours != 0"
          >{{dashIfZeroOrEmpty(job.MinHours)}} - {{dashIfZeroOrEmpty(job.MaxHours)}}</b-td>
          <b-td v-else>-</b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
export default {
  name: "DesktopJobTableSection",
  props: {
    job: Object
  },
  methods: {
    dashIfZeroOrEmpty(value) {
      if (value == 0 || value == "" || value == "01-01-0001") {
        return "-";
      } else {
        return value;
      }
    }
  }
};
</script>

<style scoped>
h4 {
  padding-bottom: 25px;
}
b-tbody {
  margin-top: 40px;
}

.table-sm th,
.table-sm td {
  padding: 0.1rem;
}

#priceVar {
  font-size: 25px;
}

#priceText {
  font-size: 25px;
}

#jobTableSection {
  margin-top: 2px;
  padding: 20px;
  font-size: 15px;
}
</style>